import Vue from 'vue'
import Vuex from 'vuex'

import * as translation from './modules/translation.js'
import * as payments from './modules/payments.js'
import * as tasks from './modules/tasks.js'
import * as user from './modules/user.js'
import * as transcribe from './modules/transcribe.js'
import * as websocket from './modules/websocket.js'
import { v4 as uuidv4 } from 'uuid'

// eslint-disable-next-line camelcase
// import jwt_decode from 'jwt-decode'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    sidebarvis: true,
    sidebarslide: false,
    sessionId: uuidv4()
  },
  modules: {
    translation,
    payments,
    tasks,
    user,
    transcribe,
    websocket
  },
  mutations: {
    SET_SIDEBARVIS (state, isVisible) {
      state.sidebarvis = isVisible
    },
    SET_SIDEBARSLIDE (state, isVisible) {
      state.sidebarslide = isVisible
    },
    LOG_OUT (state, payload) {
      state.user = null
    }
  }
})
// const token = Vue.$cookies.get(process.env.VUE_APP_AUTH_COOKIE_NAME)
// const decoded = jwt_decode(token)
// const userId = decoded.sub
// const url = process.env.VUE_APP_WEBSOCKETS + '?user_id=' + userId
// console.log('Connection on url ' + url)
// websocket.connection = new WebSocket(url)
// websocket.connection.onmessage = function (event) {
//   console.log('MESSAGE RECEIVED - event follows.... ')
//   console.log(event.data)
//   const task = JSON.parse(event.data)
//   console.log(task)
//   Vue.store.dispatch('putTask', task)
// }
